module.exports = __webpack_public_path__ + "img/金林豪生入口图.63780e02.jpg";